import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fractionDigits',
})
export class FractionDigitsPipe implements PipeTransform {
  transform(value: number): string | null {
    if (typeof value === 'number' && value !== 0) {
      let [integer, decimal] = value.toString().split('.');
      decimal = (decimal ?? '0') + '0';
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return `${integer}.${decimal}`;
    }

    if (value === 0) {
      return value.toString();
    }

    return value;
  }
}
